import _objectSpread from "@babel/runtime/helpers/objectSpread2";
export function isToday(date) {
  return areDatesEqual(date, new Date(Date.now()));
}
export function getMonthOffset(date) {
  var currentDate = new Date(Date.now());
  var newMonthOffset = date.getMonth() - currentDate.getMonth();
  var yearOffset = date.getFullYear() - currentDate.getFullYear();
  return newMonthOffset + yearOffset * 12;
}
export function addDays(currentDate, numberOfDays) {
  var nextDate = new Date(currentDate);
  nextDate.setDate(currentDate.getDate() + numberOfDays);
  return nextDate;
}
export function canSelectDate(props) {
  var _props$excludedDates;
  var minDateInclusize = props.minDate ? new Date(props.minDate) : new Date();
  minDateInclusize.setHours(0);
  minDateInclusize.setMinutes(0);
  minDateInclusize.setSeconds(0);
  minDateInclusize.setMilliseconds(0);
  var maxDateInclusize = props.maxDate ? new Date(props.maxDate) : new Date();
  maxDateInclusize.setHours(23);
  maxDateInclusize.setMinutes(59);
  maxDateInclusize.setSeconds(59);
  maxDateInclusize.setMilliseconds(99);
  var isExcluded = (_props$excludedDates = props.excludedDates) === null || _props$excludedDates === void 0 ? void 0 : _props$excludedDates.find(function (e) {
    return areDatesEqual(props.date, e);
  });
  return (!props.minDate || props.date >= minDateInclusize) && (!props.maxDate || props.date <= maxDateInclusize) && !isExcluded;
}
export function getDaysInMonth(props) {
  var lastDateOfCurrentMonth = getLastDayOfMonth(props.month);
  var year = props.month.getFullYear();
  var month = props.month.getMonth();
  var days = [];
  var startDate = props.selectedDate;
  var endDate = props.dateRange;
  if (props.dateRange && props.selectedDate && props.selectedDate > props.dateRange) {
    // this handles when `dateRange` comes before `date`, it's used when selecting an end date
    startDate = props.dateRange;
    endDate = props.selectedDate;
  }
  var hasFocusableDate = false;
  for (var d = 0; d < lastDateOfCurrentMonth; d++) {
    var date = new Date(year, month, d + 1);
    var isStartDate = Boolean(startDate && areDatesEqual(startDate, date));
    var isEndDate = Boolean(endDate && areDatesEqual(endDate, date));
    var inRange = Boolean(startDate && endDate && startDate < date && date < endDate);
    var tabIndex = getTabIndex(props, date);
    if (tabIndex === 0) {
      hasFocusableDate = true;
    }
    var day = {
      date: date,
      isFocused: props.focusedDate ? areDatesEqual(props.focusedDate, date) : false,
      inCurrentMonth: props.inCurrentMonth,
      disabled: !canSelectDate({
        date: date,
        minDate: props.minDate,
        maxDate: props.maxDate,
        excludedDates: props.excludedDates
      }),
      isSelected: isStartDate || isEndDate,
      startOfRange: Boolean(endDate && isStartDate),
      endOfRange: Boolean(startDate && isEndDate),
      inRange: inRange,
      tabIndex: tabIndex
    };
    days.push(day);
  }
  if (!hasFocusableDate) {
    var firstSelectableDay = days.findIndex(function (d) {
      return !d.disabled && d.inCurrentMonth;
    });
    if (firstSelectableDay > -1) {
      days[firstSelectableDay] = _objectSpread(_objectSpread({}, days[firstSelectableDay]), {}, {
        tabIndex: 0
      });
    }
  }
  return days;
}
function getTabIndex(props, date) {
  if (props.inCurrentMonth && props.focusedDate && props.month.getFullYear() === props.focusedDate.getFullYear() && props.month.getMonth() === props.focusedDate.getMonth()) {
    return areDatesEqual(props.focusedDate, date) ? 0 : undefined;
  }
}
function getLastDayOfMonth(date) {
  // Gets the last day of the month by getting the following month and setting the day to '0'
  return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
}
export function getFirstWeekOffset(date) {
  var firstWeek = new Date(date);
  firstWeek.setDate(1);
  return firstWeek.getDay();
}
function areDatesEqual(date1, date2) {
  return date1.getDate() === date2.getDate() && date1.getMonth() === date2.getMonth() && date1.getFullYear() === date2.getFullYear();
}